import { IconWell } from '@playbooks/molecules/icons/icon-well';
import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';
import { Badge } from '@playbooks/ui/components/badge';

export const AttachmentAvatar = ({ icon, thumbnail, title, text, badge }) => {
	// Render
	return (
		<Avatar className='flex-between w-full'>
			<span className='flex-start gap-4'>
				{thumbnail ? <AvatarImage src={thumbnail} alt={title} size='xs' /> : <IconWell icon={icon} size='sm' />}
				<AvatarContent className='group-hover:underline'>
					<AvatarDescription>{title}</AvatarDescription>
				</AvatarContent>
			</span>
			{badge && <Badge>{badge}</Badge>}
		</Avatar>
	);
};
